export enum KioskAuthenticationMode {
  OpenList = 1,
  Pin = 2,
  PinPlusPersonalDeviceApproval = 3,
}
